import Swal from 'sweetalert2'

export const swalDel = (text) => {
    return Swal.fire({
        title: 'Are you sure?',
        text,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        width: '17rem',
        padding: '0.5rem 0.65rem 0.65rem',
        customClass: {
            popup: 'swal-del-compact',
            title: 'swal-del-compact-title',
            htmlContainer: 'swal-del-compact-html',
            actions: 'swal-del-compact-actions',
            confirmButton: 'swal-del-compact-btn',
            cancelButton: 'swal-del-compact-btn',
        },
    });
};

export const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})
